import React from 'react'
import PropTypes from 'prop-types'

import { getMessage, getRetryMessage } from './error-utils'

import { Notification } from '../Notification/Notification'

import './Error.css'

const DEFAULT_ACTION_CONTENT = 'Click here to retry'

const Error = ({ error, retry, isActionable, ...props }) => {
  isActionable = Boolean(retry || isActionable)
  return (
    <Notification
      severity='error'
      isActionable={isActionable}
      actionContent={DEFAULT_ACTION_CONTENT}
      onAction={() => retry()}
      {...props}
    >
      <span data-testid='error-message'>
        {getMessage(error)}
        {!isActionable && (
          <React.Fragment>
            <br />{getRetryMessage(error) || 'Please try again'}
          </React.Fragment>
        )}
      </span>
    </Notification>
  )
}

Error.propTypes = {
  error: PropTypes.object,
  retry: PropTypes.func
}

export default Error
